/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleMovementPeriodListUpdate
 */
export interface VehicleMovementPeriodListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMovementPeriodListUpdate
     */
    eventId?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMovementPeriodListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMovementPeriodListUpdate
     */
    userEmployeeId?: boolean | null;
}

/**
 * Check if a given object implements the VehicleMovementPeriodListUpdate interface.
 */
export function instanceOfVehicleMovementPeriodListUpdate(value: object): value is VehicleMovementPeriodListUpdate {
    return true;
}

export function VehicleMovementPeriodListUpdateFromJSON(json: any): VehicleMovementPeriodListUpdate {
    return VehicleMovementPeriodListUpdateFromJSONTyped(json, false);
}

export function VehicleMovementPeriodListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleMovementPeriodListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'userEmployeeId': json['userEmployeeId'] == null ? undefined : json['userEmployeeId'],
    };
}

export function VehicleMovementPeriodListUpdateToJSON(json: any): VehicleMovementPeriodListUpdate {
    return VehicleMovementPeriodListUpdateToJSONTyped(json, false);
}

export function VehicleMovementPeriodListUpdateToJSONTyped(value?: VehicleMovementPeriodListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': value['eventId'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'userEmployeeId': value['userEmployeeId'],
    };
}

